// Native & external imports
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule  } from '@angular/router';
// Components
import { TopNavbarComponent } from './top-navbar/top-navbar.component';
import { CmpSharedModule } from 'icamppro-shared-components';
@NgModule({
  declarations: [
    TopNavbarComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CmpSharedModule
  ],
  exports: [
    TopNavbarComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class TopNavbarModule { }
